/* @flow */

import React from 'react'
import i18n from 'atpjs/helpers/i18n'
import { formatPhone, formatPhoneForTel } from 'tve/helpers/phone'
import OpeningTimes from 'tve/components/opening_times'

const t = i18n.prefix(['components', 'unattendedBranch'])

const UnattendedBranch = ({ customerType }) => {
  const phoneNumber = i18n.trans(['contactPhoneNumber', customerType])

  return (
    <>
      <p className="atp-margin-top-s atp-margin-bottom-xs">{t(['contact'])}</p>
      <div className="atp-card atp-card--icon-phone">
        <p>
          <a className="atp-notification__bold-text" href={`tel:${formatPhoneForTel(phoneNumber)}`}>
            {formatPhone(phoneNumber)}
          </a>
        </p>
        <OpeningTimes />
      </div>
      <p>{t(['text'])}</p>
    </>
  )
}

export default UnattendedBranch
